import styled from 'styled-components'

export const Container = styled.div`
	border: 1px solid #EDEEEF;
	border-radius: 12px;
	margin: 24px 10px 24px 0px;
	flex: 0 0 auto;
`
